import { render, staticRenderFns } from "./ContabilitaDocumentoRigheEditComponentN.vue?vue&type=template&id=4f9c668e&scoped=true"
import script from "./ContabilitaDocumentoRigheEditComponentN.vue?vue&type=script&lang=js"
export * from "./ContabilitaDocumentoRigheEditComponentN.vue?vue&type=script&lang=js"
import style0 from "./ContabilitaDocumentoRigheEditComponentN.vue?vue&type=style&index=0&id=4f9c668e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9c668e",
  null
  
)

export default component.exports